/**
 * Sorts an array of strings alphabetically.
 * @param {string[]} items - The array of strings to sort.
 * @returns {string[]} A new array sorted alphabetically.
 */
export const sortAlphabetically = (items: string[]): string[] => {
  return items.slice().sort((a, b) => a.localeCompare(b))
}
